export default "__VITE_ASSET__dfbb5646__"